import React from 'react'; // Rimosso useEffect e useRef che non servono più
import './Marquee.css';

const Marquee = ({ text, imageSrc }) => {
  // Se testo > 90 caratteri usa slow, altrimenti fast
  const isLongText = text && text.length > 90;
  const speedClass = isLongText ? 'Slow' : 'Fast';

  return (
    <div id="maindiv">
      {/* Prima riga */}
      <div className={`div1${speedClass}`}>
        {text ? (
          <p>{text}</p>
        ) : (
          [...Array(4)].map((_, index) => (
            <img 
              key={`img1-${index}`} 
              src={imageSrc} 
              alt={`logo-${index}`} 
              style={{ width: "230px", marginRight: "80px", verticalAlign: "middle" }} 
            />
          ))
        )}
      </div>

      {/* Seconda riga */}
      <div className={`div2${speedClass}`}>
        {text ? (
          <p>&nbsp;&nbsp;&nbsp;{text}</p>
        ) : (
          [...Array(4)].map((_, index) => (
            <img 
              key={`img2-${index}`} 
              src={imageSrc} 
              alt={`logo-${index}`} 
              style={{ width: "230px", marginRight: "80px", verticalAlign: "middle" }} 
            />
          ))
        )}
      </div>
    </div>
  );
};

export default Marquee;